/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ points: NonNullable<unknown> }} Orders_Carrier_Points_AppliedInputs */

const en_orders_carrier_points_applied = /** @type {(inputs: Orders_Carrier_Points_AppliedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.points} reward points were applied to shipping adjustment.`)
};

const es_orders_carrier_points_applied = /** @type {(inputs: Orders_Carrier_Points_AppliedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Se aplicaron ${i?.points} puntos de recompensa al ajuste de envio.`)
};

/**
* | output |
* | --- |
* | "{points} reward points were applied to shipping adjustment." |
*
* @param {Orders_Carrier_Points_AppliedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_carrier_points_applied = /** @type {((inputs: Orders_Carrier_Points_AppliedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Carrier_Points_AppliedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_carrier_points_applied(inputs)
	return es_orders_carrier_points_applied(inputs)
});